import React, { useState } from "react";
import { Card, Button, Table } from "react-bootstrap";
import Modal from "../../common/components/ThemedModal";
import { FaGamepad, FaRegHandPointRight } from "react-icons/fa";
import { LiaTimesSolid } from "react-icons/lia";
import { TbMathFunction } from "react-icons/tb";

interface MultiplierModeRulesCardProps {
	numberOfMen: number;
	numberOfWomen: number;
}

const MultiplierModeRulesCard: React.FC<MultiplierModeRulesCardProps> = ({
	numberOfMen,
	numberOfWomen,
}) => {
	const [viewScoring, setViewScoring] = useState(false);

	return (
		<Card className="mb-3 bg-secondary text-white border-0 shadow">
			<Card.Header className="fs-3 fw-bold">
				<FaGamepad className="me-2 mb-1" />
				Multiplier Mode
			</Card.Header>
			<Card.Body style={{ fontSize: "0.8rem" }}>
				<Card.Text>
					<FaRegHandPointRight className="me-2" />
					Build your dream team by selecting {numberOfMen} Men, and{" "}
					{numberOfWomen} Women.
				</Card.Text>
				<Card.Text>
					<FaRegHandPointRight className="me-2" />
					Your points are awarded by points scored by the athlete at the event
					multiplied by the athletes assigned multiplier value.
				</Card.Text>
				<Card.Text className="fst-italic">
					<FaRegHandPointRight className="me-2 " />
					Rider's Points
					<LiaTimesSolid className="mx-1 " /> Multiplier = Your Score!
				</Card.Text>
				<Card.Text className="fst-italic">
					<FaRegHandPointRight className="me-2 " />
					Dan Booker scores 50 points
					<LiaTimesSolid className="mx-1 " /> 5 (Multiplier) = 250 Points
				</Card.Text>
				<div className="d-flex flex-row justify-content-md-end justify-content-center">
					<Button variant="dark" size="sm" onClick={() => setViewScoring(true)}>
						Points
					</Button>
				</div>
			</Card.Body>
			<Card.Footer className="bg-secondary text-white">
				<div className="d-flex justify-content-between align-items-center">
					<span className="text-info small">
						Select riders strategically based on expected performance
					</span>
				</div>
			</Card.Footer>

			{/* Scoring Modal */}
			<Modal show={viewScoring} onHide={() => setViewScoring(false)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Crankworx Event Scoring</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<p>
						Scoring depends on the specific event, but generally follows points
						awarded for each rank position:
					</p>
					<Table striped bordered hover size="sm">
						<thead>
							<tr>
								<th>Position</th>
								<th>Points</th>
								<th>Position</th>
								<th>Points</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>1st</td>
								<td>100</td>
								<td>6th</td>
								<td>50</td>
							</tr>
							<tr>
								<td>2nd</td>
								<td>90</td>
								<td>7th</td>
								<td>45</td>
							</tr>
							<tr>
								<td>3rd</td>
								<td>80</td>
								<td>8th</td>
								<td>40</td>
							</tr>
							<tr>
								<td>4th</td>
								<td>70</td>
								<td>9th</td>
								<td>35</td>
							</tr>
							<tr>
								<td>5th</td>
								<td>60</td>
								<td>10th</td>
								<td>30</td>
							</tr>
						</tbody>
					</Table>
					<p className="text-muted mt-3 small">
						Note: Points may vary by competition. The exact scoring system will
						be confirmed before each event.
					</p>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={() => setViewScoring(false)}>
						Close
					</Button>
				</Modal.Footer>
			</Modal>
		</Card>
	);
};

export default MultiplierModeRulesCard;
